import React from 'react'
import { Route, RouteProps, RouteComponentProps } from 'react-router-dom'

export type TBreadcrumbItemProps = {
  active: boolean
  page: TPageProps
}

export type TPageProps = {
  name: string
  routeProps: RouteProps
  navProps?: {
    title: string
    icon?: string
  }
  breadcrumbProps?: {
    title?: string
    lookupKey?: string
    component?: React.FunctionComponent<TBreadcrumbItemProps>
  }
  children?: TPageProps[]
}

type TRoute = {
  path: string
  children?: TPageProps[]
  component?: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>
  name?: string
  props?: RouteProps
}

const getRoutes = (route: TRoute, parent?: TRoute) => {
  const routes: any[] = []
  const { path, ...rest } = route.props || { path: '/undefined' }

  let routePath: string = path as string
  if (parent) {
    routePath = `${parent.path}${route.path}`
  }

  if (route.children) {
    route.children.forEach((child) => {
      const childRoute: TRoute = {
        name: child.name,
        component: child.routeProps.component,
        path: child.routeProps.path as string,
        props: child.routeProps,
        children: child.children,
      }

      const parentRoute: TRoute = {
        path: routePath,
      }
      routes.push(...getRoutes(childRoute, parentRoute))
    })
  }

  if (route.component) {
    routes.push(<Route key={route.name} {...rest} path={routePath} />)
  }
  return routes
}

const getPageRoutes = (pages: TPageProps[]) => {
  const routes: any[] = []
  pages.forEach((page) => {
    const rootRoute: TRoute = {
      name: page.name,
      component: page.routeProps.component,
      props: page.routeProps,
      path: page.routeProps.path as string,
      children: page.children,
    }
    const pageRoutes = getRoutes(rootRoute)
    pageRoutes.forEach((pr) => routes.push(pr))
  })
  return routes
}

export default getPageRoutes
